
export enum RelationType {
  Parents = 'parents',
  Children = 'children',
  Related = 'related',
  Clean = 'archive',
  ChangeNotification = 'changeNotification', // one way relation where the items of this relation type should be notified
}

export function isRelationType(relationType: unknown): relationType is RelationType {
  if (typeof relationType !== 'string') return false;
  return Object.values(RelationType).includes(relationType as RelationType);
}

export type RelationsEntity = { [k in RelationType]?: string[] };
